import React from 'react'
import "./newcard.css"
import { NavLink } from "react-router-dom";

function Card(props) {
  return (
    <div className="card">
      <div className="card__body">
        <img src={props.img} class="card__image" />
        <h2 className="card__title">{props.title}</h2>
        <p className="card__description">{props.description}</p>
      </div>
      <NavLink className="buttonwrapper" to={'/rooms'}>
Virtual Tour 
</NavLink>
    </div>
  )
}

export default Card

